export const SCROLL_DIRECTION = {
    /* scrolling towards bottom of page */
    DOWN: 'DOWN',
    /* scrolling towards top of page */
    UP: 'UP',
};

export const IOS_APP_MINIMUM_IOS_VERSION = 13;
